<script setup lang="ts">
import Card from 'primevue/card';
import type { ShipmentOriginDestinationView } from '@/utils/shipment-detail-stops';
import { formatShipmentDateTime } from '@/utils/shipment-detail-format';
import { shipmentDetailCardPt } from '@/components/shipment/detail/shipment-detail-card-pt';

defineProps<{
  originDestination: ShipmentOriginDestinationView;
}>();

const cardPt = shipmentDetailCardPt;
</script>

<template>
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
    <Card :pt="cardPt">
      <template #content>
        <div class="mb-3 flex items-center gap-2">
          <span class="size-2.5 shrink-0 rounded-full bg-green-500" />
          <span class="text-sm font-semibold text-green-700">Origin</span>
        </div>
        <p class="mb-3 text-sm font-medium text-neutral-900">
          {{ originDestination.originAddress }}
        </p>
        <dl class="space-y-2">
          <div class="flex items-center justify-between">
            <dt class="text-sm text-neutral-500">Planned Pickup</dt>
            <dd class="text-sm font-medium text-neutral-900">
              {{ formatShipmentDateTime(originDestination.plannedPickup) }}
            </dd>
          </div>
          <div class="flex justify-between">
            <dt class="text-sm text-neutral-500">Actual Pickup</dt>
            <dd
              class="text-sm font-medium"
              :class="
                originDestination.actualPickup
                  ? 'text-green-600'
                  : 'text-neutral-400'
              "
            >
              {{ formatShipmentDateTime(originDestination.actualPickup) }}
            </dd>
          </div>
        </dl>
      </template>
    </Card>

    <Card :pt="cardPt">
      <template #content>
        <div class="mb-3 flex items-center gap-2">
          <span class="size-2.5 shrink-0 rounded-full bg-slate-700" />
          <span class="text-sm font-semibold text-slate-700">Destination</span>
        </div>
        <p class="mb-3 text-sm font-medium text-neutral-900">
          {{ originDestination.destinationAddress }}
        </p>
        <dl class="space-y-2">
          <div class="flex items-center justify-between">
            <dt class="text-sm text-neutral-500">Planned Delivery</dt>
            <dd class="text-sm font-medium text-neutral-900">
              {{ formatShipmentDateTime(originDestination.plannedDelivery) }}
            </dd>
          </div>
          <div class="flex justify-between">
            <dt class="text-sm text-neutral-500">Actual Delivery</dt>
            <dd
              class="text-sm font-medium"
              :class="
                originDestination.actualDelivery
                  ? 'text-green-600'
                  : 'text-neutral-400'
              "
            >
              {{ formatShipmentDateTime(originDestination.actualDelivery) }}
            </dd>
          </div>
        </dl>
      </template>
    </Card>
  </div>
</template>
